import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";

import submit from "submit-form";
import Modal from "../../../parts/modal-new";

import AccordionRadio from "./AccordionRadio";
import { defaultFirebaseProjectId } from "../../../constants";
import OptionToggler from "../../../parts/OptionToggler";
import Select from "../../../parts/inputs/select";
import { getUserAccess } from "../../../utils/organization-helpers";
import { SearchDropdown } from "../../../parts/inputs/search-dropdown";

const TYPES_MAP = {
  template: "coach",
  otherAthlete: "coach",
  store: "subscription",
};

class FetchCycleModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      fetchType: "template",
      sourceOwner: String(context.locals.activeUserToRequest._id),
      submited: false,
    };
  }

  handleAthleteChange(sourceOwner) {
    this.setState({ sourceOwner });
  }

  handleFetchTypeChange(fetchType) {
    const newState = { fetchType, sourceCycleId: "" };
    newState.sourceOwner =
      ["template", "store"].includes(fetchType) &&
      String(this.context.locals.activeUserToRequest._id);
    this.setState(newState);
  }

  fetch(cycleId, destinationCycleId, programOrder, e) {
    e.preventDefault();
    const {
      query: { athlete },
      activeUserToRequest,
      activeUser,
    } = this.context.locals;
    const { submited } = this.state;
    if (submited) return;
    const recipient = athlete
      ? String(athlete)
      : String(activeUserToRequest._id);
    const coachAvatar =
      !!activeUser.avatar && !!activeUser.avatar.file
        ? activeUser.avatar.file
        : null;
    const firebaseProjectId = !!activeUserToRequest.firebaseProjectId
      ? activeUserToRequest.firebaseProjectId
      : defaultFirebaseProjectId;
    this.setState({ submited: true });
    submit(`/actions/cycle/send/?source=fetch`, {
      method: "POST",
      body: {
        cycleId,
        destinationCycleId,
        programOrder,
        recipients: [recipient],
        subscription: this.props.subscription || false,
        status: this.context.locals.query.destinationCycleStatus
          ? this.context.locals.query.destinationCycleStatus
          : "draft",
        avatar: coachAvatar,
        firebaseProjectId,
      },
    });
  }

  render() {
    const {
      sourceOwner,
      sourceCycleId,
      fetchType = "template",
      programOrder,
    } = this.state;
    const { locals } = this.context;
    const { isAllowToViewAllOrganizationsAthletes } = this.props;
    const {
      query = {},
      copiableCycles,
      activeUserToRequest: { referAsClients },
      activeUser: { athletes },
      allAthletesFromOrganization,
      organizationOwner,
      organizationPermissions,
      organizationRoles,
    } = locals;
    const { userCanAccessToPush } = getUserAccess(
      locals.activeUser,
      organizationOwner,
      organizationPermissions,
      organizationRoles
    );

    let { sendToAnother, destinationCycleId, destinationCycleName } = query;
    const prefix = destinationCycleId ? "Program" : "Block";
    const athletesOptions = [];

    if (
      !allAthletesFromOrganization ||
      !isAllowToViewAllOrganizationsAthletes
    ) {
      _.each(athletes, (athlete) => {
        athletesOptions.push({
          value: athlete._id,
          label: athlete.name,
        });
      });
    } else {
      _.each(allAthletesFromOrganization, ({ athleteId, athleteName }) => {
        athletesOptions.push({
          value: athleteId,
          label: athleteName,
        });
      });
    }

    const cyclesOptions = [];
    copiableCycles.forEach((cycle) => {
      if (
        String(cycle.owner._id) === sourceOwner &&
        cycle.type === TYPES_MAP[fetchType]
      )
        cyclesOptions.push({
          value: cycle._id,
          label: `${cycle.name}${
            fetchType === "store" ? ` (${_.capitalize(cycle.status)})` : ""
          }`,
        });
    });

    const sourceCycle = _.find(copiableCycles, { _id: sourceCycleId });

    const isValid =
      sourceOwner && !!sourceCycle && !!destinationCycleId === !!programOrder;

    const fetchOptions = [
      { value: "template", label: "From template" },
      {
        value: "otherAthlete",
        label: `From another ${referAsClients ? "client" : "athlete"}`,
      },
    ];
    if (userCanAccessToPush) {
      fetchOptions.push({ value: "store", label: "From store" });
    }

    return (
      <Modal
        toClear={["sendToAnother", "destinationCycleId"]}
        className="fetch-modal"
        title={`Copy ${prefix} From`}
      >
        <div className="body">
          <OptionToggler
            name="fetchType"
            options={fetchOptions}
            defaultValue={fetchType}
            onSelectFn={(value) => this.handleFetchTypeChange(value)}
          />

          {fetchType === "otherAthlete" && (
            <>
              <label>Select {referAsClients ? "client" : "athlete"}</label>
              <input
                type="hidden"
                value={sourceOwner}
                name="fetch-modal-athletes"
              />
              <SearchDropdown
                name="fetch-modal-athletes"
                options={athletesOptions}
                handleChange={(option) =>
                  this.handleAthleteChange(option.value)
                }
                title={`Copy ${prefix} from ${
                  referAsClients ? "client" : "athlete"
                }`}
                value={
                  athletesOptions.find(
                    (athlete) => athlete.value === sourceOwner
                  )?.label || "Select"
                }
                valueKey="label"
              />
            </>
          )}
          {sourceOwner && (
            <>
              <label>Select Program</label>
              <input
                type="hidden"
                value={sourceCycleId}
                name="fetch-modal-cycles"
              />
              <SearchDropdown
                options={cyclesOptions}
                handleChange={(option) =>
                  this.setState({ sourceCycleId: option.value })
                }
                value={
                  cyclesOptions.find((option) => option.value === sourceCycleId)
                    ?.label || "Select"
                }
                valueKey="label"
              />
            </>
          )}

          {!destinationCycleId && sourceCycle && (
            <div className="group fetch-cycle-summary">
              <p className="chip info">
                A Copy of the following {prefix} will be added to{" "}
                {_.get(locals, "athlete.name", "")}
                's Athelete Portal.
              </p>

              <AccordionRadio
                cycleId={sourceCycleId}
                cycleName={sourceCycle.name}
                programsCount={sourceCycle.programs.length}
              >
                {_.get(sourceCycle, "programs", []).map((program) => (
                  <div className="program">
                    <span className="count">{program.order}</span>
                    <span className="name">{program.name}</span>
                  </div>
                ))}
              </AccordionRadio>
            </div>
          )}

          {destinationCycleId && sourceCycle && (
            <Select
              name="fetchmodal-programs"
              title={`Select Block`}
              options={sourceCycle.programs.map((prog) => ({
                value: prog.order,
                label: prog.name,
              }))}
              // openOnClick={false}

              onChange={(programOrder) => this.setState({ programOrder })}
              value={programOrder || "Select"}
            />
          )}

          {destinationCycleId && sourceCycle && programOrder && (
            <div className="group fetch-program-summary">
              <p className="chip info">
                The following {prefix} will be added to {destinationCycleName}.
              </p>

              <AccordionRadio
                cycleId={sourceCycleId}
                cycleName={sourceCycle.name}
                programsCount={sourceCycle.programs.length}
              >
                <div className="program">
                  <span className="count" />
                  <span className="name">
                    {sourceCycle.programs[programOrder - 1].name}
                  </span>
                </div>
              </AccordionRadio>
            </div>
          )}
        </div>

        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal=&sourceOwner="
          >
            Cancel
          </a>
          <button
            type="submit"
            data-button-type="primary"
            disabled={!isValid ? true : undefined}
            onClick={(e) =>
              this.fetch(sourceCycleId, destinationCycleId, programOrder, e)
            }
          >
            Add {destinationCycleId ? "Block" : "Program"}
          </button>
        </footer>
      </Modal>
    );
  }
}

FetchCycleModal.contextTypes = { locals: PropTypes.object };

export default FetchCycleModal;
